import { CreateElement, VNode, VNodeData, VNodeChildren } from 'vue';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { MapActions, MapGetters } from '@/utils';
import { MessageBox } from '@/components/';
import { getLoggedUser } from '@/services/api';

@Component({
  name: 'VerifyEmail',
})
export default class VerifyEmail extends Vue {
  // tslint:disable-next-line: variable-name
  @Prop({type: String, default: ''}) public readonly id_user!: string;
  // tslint:disable-next-line: variable-name
  @Prop({type: String, default: ''}) public readonly email_token!: string;

  private rendered: boolean = false;
  private error: boolean = false;
  private verifyUserEmail;
  private verifyEmail;

  @MapGetters(['verifyEmail'])

  @MapActions(['verifyUserEmail'], 'accounts')

  public get messages() {
    return this.error ? this.verifyEmail.error : this.verifyEmail.success;
  }

  public mounted() {
    this.verifyUserEmail({id: this.id_user, key: this.email_token}).then((response) => {
      if (response.status === 200) {
        getLoggedUser();
      } else if (response.status === 400 || response.status > 401) {
        this.error = true;
      }
      this.rendered = true;
    })
    .catch((error) => {
      console.error(error);
    });
  }

  public render(createElement: CreateElement) {
    const { title, link, text, buttonText } = this.messages;
    return createElement('transition',
    {
      props: {
        name: 'fade',
        mode: 'out-in',
      },
    },
    [
      this.rendered && createElement(MessageBox, {
        props: {
          title, link, text, buttonText,
        },
      }),
    ]);
  }
}
